var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8AD53A6E-D6EB-4413-B053-5E0A9AF2EE48") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-history-view",
    transform: "translate(-1169, -585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(1157, 576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shopping_cart-icon",
    transform: "translate(12, 9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,22 C6.45,22 5.97917,21.8042 5.5875,21.4125 C5.19583,21.0208 5,20.55 5,20 C5,19.45 5.19583,18.9792 5.5875,18.5875 C5.97917,18.1958 6.45,18 7,18 C7.55,18 8.02083,18.1958 8.4125,18.5875 C8.80417,18.9792 9,19.45 9,20 C9,20.55 8.80417,21.0208 8.4125,21.4125 C8.02083,21.8042 7.55,22 7,22 Z M17,22 C16.45,22 15.9792,21.8042 15.5875,21.4125 C15.1958,21.0208 15,20.55 15,20 C15,19.45 15.1958,18.9792 15.5875,18.5875 C15.9792,18.1958 16.45,18 17,18 C17.55,18 18.0208,18.1958 18.4125,18.5875 C18.8042,18.9792 19,19.45 19,20 C19,20.55 18.8042,21.0208 18.4125,21.4125 C18.0208,21.8042 17.55,22 17,22 Z M6.15,6 L8.55,11 L15.55,11 L18.3,6 L6.15,6 Z M7,17 C6.25,17 5.68333,16.6708 5.3,16.0125 C4.91667,15.3542 4.9,14.7 5.25,14.05 L6.6,11.6 L3,4 L1.975,4 C1.69167,4 1.45833,3.90417 1.275,3.7125 C1.09167,3.52083 1,3.28333 1,3 C1,2.71667 1.09583,2.47917 1.2875,2.2875 C1.47917,2.09583 1.71667,2 2,2 L3.625,2 C3.80833,2 3.98333,2.05 4.15,2.15 C4.31667,2.25 4.44167,2.39167 4.525,2.575 L5.2,4 L19.95,4 C20.4,4 20.7083,4.16667 20.875,4.5 C21.0417,4.83333 21.0333,5.18333 20.85,5.55 L17.3,11.95 C17.1167,12.2833 16.875,12.5417 16.575,12.725 C16.275,12.9083 15.9333,13 15.55,13 L8.1,13 L7,15 L18.025,15 C18.3083,15 18.5417,15.0958 18.725,15.2875 C18.9083,15.4792 19,15.7167 19,16 C19,16.2833 18.9042,16.5208 18.7125,16.7125 C18.5208,16.9042 18.2833,17 18,17 L7,17 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.845bdaea992f84e33cf8ad0fcc1e68dd.svg";
export { ForwardRef as ReactComponent };